.select-all > div {
    position: relative;
    float: left;
}

.select-all input[type='checkbox'] {
    margin: 11px 18px 5px 16px;
}

.select-all label {
    position: absolute;
    padding: 10px;
    left: 12px;
    top: 6px;
}

.column-button:focus {
    outline: 2px solid var(--focus-blue);
    outline-offset: -3px; /* This makes the outline visible inside the column header */
}
